import {Alert, Box, Button, Stack, Typography} from "@mui/material";
import {type ApplicationCreateDtoCategoryEnum, PassCategorySelect} from "@/modules/exam-applications/shared";
import {BackLink} from "@/global/components/BackLink";
import KaspiLogo from "@/global/icons/KaspiLogo";
import {FreedomLogo} from "@/global/icons/FreedomLogo";
import {EmailInput} from "@/global/components/EmailInput";
import {type MouseEvent, useState} from "react";
import {z} from "zod";
import {toast} from "react-toastify";

interface Props {
    isPending: boolean;
    returnFirstStep: () => void,
    handleStartOnlineTransaction: (e: MouseEvent<HTMLButtonElement>, email: string, category: ApplicationCreateDtoCategoryEnum) => void,
}

export function ApplicationRegisterOnlineForm({isPending, handleStartOnlineTransaction, returnFirstStep}: Props) {
    const [email, setEmail] = useState<string>("");
    const [category, setCategory] = useState<ApplicationCreateDtoCategoryEnum>(1);

    const handleClickSystem = (e: MouseEvent<HTMLButtonElement>) => {
        const parse = z.string().email().safeParse(email);
        if (!parse.success) {
            toast.error('Ошибка при введение почтового ящика');
            return;
        }
        handleStartOnlineTransaction(e, email, category);
    };

    return (
        <Stack
            width={{lg: '60%', xs: '100%'}}
            flexDirection={'column'}
            gap={2}
            sx={{
                margin: '0 auto',
                p: 4,
                borderRadius: '26px',
                background: '#F5F5F5',
                gap: '16px'
            }}
        >
            <BackLink
                label={'Вернуться к вводу ИИН'}
                onClick={returnFirstStep}
                sx={{
                    alignSelf: 'flex-start'
                }}
            />
            <Stack
                component="form"
                gap={2}
            >
                <EmailInput
                    label={'Почтовый ящик'}
                    onChange={setEmail}
                    value={email}
                />

                <PassCategorySelect
                    value={category}
                    onChange={(e) => {
                        setCategory(+e.target.value as ApplicationCreateDtoCategoryEnum);
                    }}
                    label="Категория"
                />

                <Alert
                    sx={{
                        mt: 2
                    }}
                    severity={'info'}
                >
                    После оплаты на этой странице, а также на почту вы получите ссылку на онлайн прохождение экзамена.
                    Экзамен будет длиться 40 минут, необходимо ответить минимум на 32 вопроса
                </Alert>

                <Stack gap={2}>
                    <Typography fontSize={'16px'}>
                        Платежная система:
                    </Typography>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: {xs: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)'},
                            gap: 2
                        }}
                    >
                        <Button
                            onClick={handleClickSystem}
                            data-id={'kaspi'}
                            disabled={isPending}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                cursor: 'pointer',
                                borderRadius: '12px',
                                border: '4px solid transparent',
                                padding: 4,
                                backgroundColor: 'rgb(235, 45, 41)',
                                transition: 'all 0.5s',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'rgb(195,38,34)',
                                },
                            }}
                        >
                            <KaspiLogo/>
                        </Button>
                        <Button
                            onClick={handleClickSystem}
                            data-id={'freedom'}
                            disabled={isPending}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                borderRadius: '12px',
                                height: '100%',
                                border: '4px solid transparent',
                                backgroundColor: 'rgba(100,255,162)',
                                transition: 'all 0.5s',
                                padding: 4,
                                '&:hover': {
                                    backgroundColor: 'rgba(1,142,57)',
                                },
                            }}
                        >
                            <FreedomLogo/>
                        </Button>
                    </Box>
                </Stack>
            </Stack>
        </Stack>
    );
}